module.exports = __webpack_public_path__ + "static/media/complete-grey.4e09a367.svg";